import React, { useEffect } from "react";


const CorporateGovernance: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const policySections = [
    {
      title: `${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `Reviewed by Board of Directors
Approved on: 15 April 2025

BACKGROUND

The Corporate Governance Policy ('Policy') provides the framework under which the Board of Directors operates. It includes the Company's corporate structure, culture, policies and the manner in which it deals with various stakeholders. The Policy has been aligned with the Companies Act, 2013 ('Act'), SEBI (Listing Obligations and Disclosure Requirements) Regulations, 2015 ('SEBI Listing Regulations'), and the provisions of Corporate Governance guidelines as stipulated by the Master Direction - Non-Banking Financial Company - Systemically Important Non-Deposit taking Company and Deposit taking Company (Reserve Bank) Directions, 2016 issued by RBI vide its Circular No. DNBR. PD. 008/03.10.119/2016-17 dated 1 September 2016 as amended.`,
    },
    {
      title: "A. BOARD OF DIRECTORS",
      list: [
        `The Board is responsible to act in the best interests of the Company and its shareholders. Directors shall comply with the Code of Conduct as adopted by the Board.`,
        `The Board shall have an optimum combination of executive and non-executive directors with at least one independent woman director. At least 50% of the Board shall comprise non-executive directors.`,
        `If the non-executive chairperson is a promoter or related to promoter/management, at least half the Board shall consist of independent directors.`,
      ],
    },
    {
      title: "B. BOARD MEETINGS",
      list: [
        "Meetings shall be held at least four times a year, with maximum gap of 120 days between meetings.",
        "Minimum statutory information as per SEBI Listing Regulations shall be provided to Directors.",
      ],
    },
    {
      title: "C. COMMITTEES OF THE BOARD",
      list: [
        "1. Audit Committee: Two-thirds members as independent directors; Chairman also independent. Meets at least 4 times a year; quorum ≥2 members or 1/3 of members (whichever is greater).",
        "2. Nomination and Remuneration Committee: Minimum three non-executive directors, two-thirds independent. Meets at least once a year; quorum ≥2 members or 1/3 of members (whichever is greater).",
        "3. Stakeholders Relationship Committee: Minimum three directors, at least one independent; Chairman non-executive. Meets at least once a year.",
        "4. Risk Management Committee: Minimum three members, majority being Board members including at least one independent director. Meets at least twice a year; quorum ≥2 members or 1/3 of members (whichever is higher).",
        "5. Corporate Social Responsibility Committee: Minimum three directors, at least one independent; formulates CSR policy.",
        "6. IT Strategy Committee: Chairperson independent; meets as per prescribed frequency.",
        "7. Customer Service Committee: Oversees service initiatives, grievance redressal, Fair Practices Code compliance; meets as prescribed.",
        "8. Asset Liability Management Committee (ALCO): Top management members; manages liquidity and risk limits; headed by MD.",
        "Board may constitute other committees as required.",
      ],
    },
    {
      title: "D. VIGIL MECHANISM",
      content: "The Company shall formulate a vigil mechanism/whistleblower policy to report unethical behavior, fraud, or Code of Conduct violations. Reports can be made without fear of victimization. Policy will be hosted on Company website.",
    },
    {
      title: "E. FIT & PROPER CRITERIA",
      content: "Board-approved policy for directors' fit and proper criteria at appointment and continuously. Declaration, undertaking, and Deed of Covenant from directors required. Quarterly statements to RBI on director changes and compliance within 15 days of quarter-end.",
    },
    {
      title: "F. DISCLOSURE AND TRANSPARENCY",
      list: [
        "Progress on risk management system and policy.",
        "Conformity with corporate governance standards: Board composition, committee roles, meetings, compliance.",
        "Annual Financial Statements disclosures: registration/licence, credit ratings, penalties, JV/overseas subsidiary info, ALM, off-balance sheet exposures, securitization/structured products.",
      ],
    },
    {
      title: "G. ROTATION OF STATUTORY AUDITORS / AUDIT FIRM",
      content: "Chartered Accountant firm partner rotation every three years; rotated partner eligible after 3-year interval. Terms incorporated in audit appointment letter, following RBI guidelines.",
    },
    {
      title: "H. CEO/CFO CERTIFICATION",
      content: "MD & CEO and CFO to certify financial statements, internal controls as per Act and SEBI Listing Regulations. Policy subject to periodic Board review.",
    },
    {
      title: "Place & Date",
      list: ["Place: New Delhi", "Date: 15 April 2025"],
    },
  ];

  return (
    <div className="min-h-screen bg-[#EFFFFD] font-['Inter',sans-serif] pt-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-4">
            Corporate Governance
          </h1>
          <p className="text-lg text-[#2C3E50]/80 max-w-3xl mx-auto">
            At{" "}
            <span className="font-semibold text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            , operated by{" "}
            <span className="text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NBFC}
            </span>
            , we maintain the highest standards of corporate governance, ensuring transparency, accountability, and integrity in all our operations.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-bold text-[#2C3E50] border-b-2 border-[#21A6B5]/30 pb-2">
                {section.title}
              </h2>
              {section.content && (
                <p className="text-[#2C3E50]/80 text-base whitespace-pre-line leading-relaxed">
                  {section.content}
                </p>
              )}
              {section.list && (
                <ul className="list-disc list-outside ml-6 space-y-2 text-[#2C3E50]/80 text-base">
                  {section.list.map((li, i) => (
                    <li key={i} className="pl-1">{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default CorporateGovernance;
